import { create } from 'zustand';

/** Tipo de entidade exibida no modal de "peek" da busca global. */
export type PeekKind = 'company' | 'originator' | 'person';

export interface PeekEntity {
  kind: PeekKind;
  name: string;
  /** Linha secundária: setor (empresa), tipo (originadora), e-mail/originadora (pessoa). */
  secondary?: string | null;
}

/**
 * Estado global do modal de "peek" de Empresa/Originadora/Pessoa, aberto pela busca da topbar.
 * Como ainda não há fichas completas dessas entidades (Onda 2), o peek é read-only e mínimo —
 * fiel ao mock app.jsx (openEmpresa/openOriginadora abrem um modal). Ficha completa é follow-up.
 */
interface PeekState {
  entity: PeekEntity | null;
  open: (entity: PeekEntity) => void;
  close: () => void;
}

export const useEntityPeek = create<PeekState>()((set) => ({
  entity: null,
  open: (entity) => set({ entity }),
  close: () => set({ entity: null }),
}));
